import type { ReactNode } from 'react';
import { useFechar } from '../../input/useAtalhos';
import { ItemIcon } from '../ItemIcon';
import { IconeHud } from './icones';

export function MenuPop({
  id, titulo, x, onFechar, esc = true, children
}: {
  id: string;
  titulo: string;
  x: number;
  onFechar(): void;
  esc?: boolean;
  children: ReactNode;
}) {
  useFechar(onFechar, { ativo: esc });
  return (
    // Sem barra de título (techspec-hud-v3 §19): o menu nasce embaixo do botão que o abriu. Fecha no Esc, no
    // mesmo botão ou clicando fora (WorldScreen); o nome fica só para o leitor de tela.
    <section className="win gump pop pop--sem-titulo" data-pop={id} style={{ left: x, top: 62 }} aria-label={titulo}>
      <h2 className="sr">{titulo}</h2>
      <div className="gump__body">{children}</div>
    </section>
  );
}

export function LinhaPop({
  defId, svg, imagem, nome, meta, dir, desligada, destaque, pip, classe, onClick
}: {
  defId?: string | null;
  svg?: string;
  /** Arte do cliente do UO em `public/` (ex.: o livro de magias do Treinar), no lugar do ícone de item. */
  imagem?: string;
  nome: string;
  meta: string;
  dir: ReactNode;
  desligada?: boolean;
  /** A linha da meta em dourado (ex.: um chamado de suporte precisa do jogador). */
  destaque?: boolean;
  /** Número antes da seta (as cartas novas do correio). */
  pip?: number;
  /** Classe a mais na linha (a do correio fica dourada com carta nova). */
  classe?: string;
  onClick?: () => void;
}) {
  return (
    <button type="button" className={classe ? `mkt-ci ${classe}` : 'mkt-ci'} aria-disabled={desligada || undefined} onClick={onClick}>
      {imagem
        ? (
          <span className="itemicon" style={{ width: 28, height: 28, display: 'grid', placeItems: 'center' }}>
            <img src={imagem} alt="" draggable={false} style={{ height: 26, width: 'auto', imageRendering: 'pixelated' }} />
          </span>
        )
        : defId
        ? <ItemIcon id={defId} size={28} eager />
        : (
          <span className="itemicon" style={{ width: 28, height: 28 }}>
            {svg ? <IconeHud nome={svg} className="ic-linha" /> : null}
          </span>
        )}
      <span><span className="mkt-ci__n">{nome}</span><span className={destaque ? 'mkt-ci__m is-chama' : 'mkt-ci__m'}>{meta}</span></span>
      <span className="mkt-ci__p">{!!pip && <span className="kit-pip">{pip > 99 ? '99+' : pip}</span>}<b>{dir}</b></span>
    </button>
  );
}
